/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { View } from "react-native";
import { useSelector } from "react-redux";
import { RootState } from "store/types";

import {
  DayRangePicker,
  ProfileImage,
  Text,
  UserSearchBar,
  styles,
} from "UpduoLibrary";
import {
  skaleWebFillStormy,
  skaleWebTextGray,
  skaleWebTextLightGray,
  upduoPrimaryBlack,
} from "config/UpduoColors";
import SkillFilter from "./SkillFilter";
import { GraphViewProps } from ".";

function StatEntry({ datum, text }) {
  if (datum) {
    return (
      <Text style={{ fontSize: 12, marginRight: 15 }}>
        <Text style={{ color: upduoPrimaryBlack }}>{text}</Text>
        <Text style={{ fontWeight: "bold", color: upduoPrimaryBlack }}>
          {datum}
        </Text>
      </Text>
    );
  }
  return null;
}

export default function GraphHeader({
  exploreObject,
  dashboardName,
  onChangeFilterSkill,
}: GraphViewProps) {
  const filterSkillId = useSelector((state: RootState) => state.filterSkillId);
  const skillList = useSelector((state: RootState) => state.skillList);

  let leaderTitle = "";
  switch (exploreObject.category) {
    case "region":
      leaderTitle = "REGIONAL DIRECTOR";
      break;
    case "district":
      leaderTitle = "DISTRICT MANAGER";
      break;
    case "store":
    case "user":
      leaderTitle = "STORE MANAGER";
      break;
    default:
      break;
  }
  // TODO This is probably not the best way to check if the user is the store manager
  const isStoreManager =
    exploreObject.profileImgLgUrl && exploreObject.leader
      ? exploreObject.leader.profileImgUrl === exploreObject.profileImgLgUrl
      : false;
  const detailBar = (
    <View style={[styles.subHeaderContainer]}>
      {exploreObject.profileImgLgUrl || exploreObject.profileImgSmUrl ? (
        <View style={{ width: 127 }} />
      ) : null}
      {exploreObject.leader && !isStoreManager ? (
        <View style={{ width: 2, backgroundColor: skaleWebFillStormy }} />
      ) : null}
      {exploreObject.leader && !isStoreManager ? (
        <View style={{ alignSelf: "center", width: 250, marginLeft: 12 }}>
          <Text style={{ color: skaleWebTextLightGray, fontSize: 12 }}>
            {leaderTitle}
          </Text>
          <Text style={{ fontWeight: "bold", color: skaleWebTextGray }}>
            {`${exploreObject.leader.firstName} ${exploreObject.leader.lastName}`}
          </Text>
        </View>
      ) : null}
      <View
        style={{
          paddingBottom: 15,
          justifyContent: "center",
          display: "flex",
          flexDirection: "row",
        }}
      >
        <StatEntry datum={exploreObject.districtCount} text={"DISTRICTS: "} />
        <StatEntry datum={exploreObject.storeCount} text={"STORES: "} />
        <StatEntry datum={exploreObject.userCount} text={"EMPLOYEES: "} />
        <StatEntry datum={exploreObject.email} text={"EMAIL\n"} />
      </View>
    </View>
  );
  const hasDetail =
    exploreObject.districtCount ||
    exploreObject.storeCount ||
    exploreObject.userCount ||
    exploreObject.profileImgLgUrl ||
    exploreObject.profileImgSmUrl;

  const fullDataQueryType = useSelector(
    (state: RootState) => state.fullDataQueryType
  );
  const managerTabIsOpen = !fullDataQueryType;

  return (
    <View style={{ zIndex: 5 }}>
      <View
        style={{
          flexDirection: "row",
          paddingRight: 10,
          height: 50,
          alignItems: "center",
        }}
      >
        <View>
          <Text>
            <Text
              isHeading={true}
              style={{
                fontSize: 24,
                color: skaleWebTextGray,
                marginLeft:
                  exploreObject.profileImgLgUrl || exploreObject.profileImgSmUrl
                    ? 110
                    : 0,
              }}
            >
              {dashboardName}
            </Text>
            {exploreObject.title ? (
              <Text
                style={{
                  color: skaleWebTextLightGray,
                  fontSize: 12,
                  marginLeft: 10,
                }}
              >
                {exploreObject.title.toUpperCase()}
              </Text>
            ) : null}
          </Text>
        </View>
        <View
          style={{
            flex: 1,
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          {!managerTabIsOpen ? (
            <>
              {skillList.length > 0 ? (
                <View style={{ marginBottom: 11 }}>
                  <SkillFilter
                    value={filterSkillId}
                    onChange={onChangeFilterSkill}
                    primaryText={"All Lessons"}
                    optionList={skillList.sort((a, b) =>
                      a.name.localeCompare(b.name)
                    )}
                  />
                </View>
              ) : null}
              <DayRangePicker />
            </>
          ) : null}
          <UserSearchBar />
        </View>
      </View>
      {hasDetail ? detailBar : null}
      {hasDetail ? (
        <ProfileImage
          userObject={exploreObject.email ? exploreObject : undefined}
          style={{
            position: "absolute",
            bottom: 12,
            left: 20,
          }}
          size={86}
        />
      ) : null}
    </View>
  );
}
